import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./Note.module.scss";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
} from "reactstrap";
import { FormattedDate, FormattedNumber, FormattedTime } from "react-intl";
import { CircularProgress, OrderInlineDetail } from "../..";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { localDateTime } from "../../../utils/Helper";

class OldNote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      note: "",
      notes: null,
      loading: true,
    };
  }

  componentWillReceiveProps(nextProps, nextState) {
    const { orderId } = nextProps;

    if (orderId && !this.state.notes) {
      this.props.onNoteRequest({ orderId }).then((response) => {
        this.setState({
          loading: false,
          notes: response.response.notes,
        });
      });
    }
  }

  toggle = () => {
    this.props.onToggle();
    this.setState({ notes: null, loading: true });
  };

  addNote = () => {
    const { orderId } = this.props;

    this.props.onAddRequest({ orderId, note: { text: this.state.note } }).then((response) => {
      this.setState({
        note: "",
        notes: [response.response.note, ...this.state.notes],
      });
    });
  };

  deleteNote = (noteDate) => {
    const { orderId } = this.props;

    this.props.onRemoveRequest({ orderId, noteDate }).then((response) => {
      this.setState({
        notes: this.state.notes.filter((item) => item.createdAt !== noteDate),
      });
    });
  };

  render() {
    const { order } = this.props;
    const { loading } = this.state;

    if (!this.props.open) {
      return null;
    }

    return (
      <div>
        <Modal isOpen={this.props.open} toggle={this.toggle} className={style.modal}>
          <ModalHeader toggle={this.toggle}>
            Order note
            <OrderInlineDetail order={order} />
          </ModalHeader>
          <ModalBody style={{ padding: "10px 8px" }}>
            <Container>
              <Row>
                <Col xs="12" style={{ textAlign: "center" }}>
                  <Input
                    style={{ marginBottom: "10px" }}
                    type="textarea"
                    rows="2"
                    placeholder="Note"
                    value={this.state.note}
                    onChange={(e) => this.setState({ note: e.target.value })}
                  />

                  <LaddaButton
                    className="btn btn-ladda btn-primary"
                    loading={loading}
                    disabled={this.state.note == ""}
                    onClick={() => this.addNote()}
                    data-style={SLIDE_LEFT}
                  >
                    {"Confirm"}
                  </LaddaButton>
                </Col>
              </Row>
              <h5 className={style.subtitle}>Notes</h5>
              {this.state.loading ? (
                <CircularProgress />
              ) : (
                <Table responsive size="sm" className={style.tableNote}>
                  <thead></thead>
                  <tbody>
                    <NotesRows notes={this.state.notes} delete={this.deleteNote} />
                  </tbody>
                </Table>
              )}
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={this.toggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const NotesRows = (props) => {
  if (!props.notes.length) {
    return (
      <tr>
        <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
          <h5 style={{ textAlign: "center" }}>No Notes</h5>
        </td>
      </tr>
    );
  }

  return props.notes.map((note) => {
    return (
      <tr key={`note-${note.createdAt}`}>
        <td>
          <span className={style.user}>{note.createdBy}</span>
        </td>
        <td>
          <small color="secondary">
            <FormattedDate value={localDateTime(note.createdAt)} />{" "}
            <FormattedTime value={localDateTime(note.createdAt)} hour12={false} />
          </small>
          <br />
          <p className={style.detail}>{note.text}</p>
        </td>
        <td>
          <Button
            onClick={() => props.delete(note.createdAt)}
            className={style.iconDelete}
            color="danger"
            size="sm"
          >
            <i className="fa fa-trash-o"></i>
          </Button>
        </td>
      </tr>
    );
  });
};

export default OldNote;
